import axios from "axios";
import { Message } from "element-ui";
import md5 from "js-md5";

// 配置公共的URL路径
// var Host = "http://10.30.96.34/hisa_apis"; // 正式
var Host = "https://www.emsjqsd.com/hisa_apis"; // 正式
// var Host = "http://test.emsjqsd.com/hisa_apis"; // 测试
// var Host = "http://10.8.117.137:9044/"; // 吴美琴
// Host = "http://10.8.205.47:9044/"; // 小杨磊
// Host = 'http://10.8.205.35:9044/'; // 陈力
// Host = "https://tdll-api.chinatdll.com/data-center";

// Host = "http://10.8.205.47:9099/";

const service = axios.create({
  baseURL: Host,
  timeout: 50000000
});

function getRadomNum(capacity) {
  let chars = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];
  let res = "";
  for (let i = 0; i < capacity; i++) {
    var id = Math.ceil(Math.random() * chars.length);
    res += chars[id];
  }
  return res;
}


service.interceptors.request.use(
  config => {
    let timestamp = new Date().getTime();
let appId = sessionStorage.getItem("appId"); //来源端
let appSecret = sessionStorage.getItem("appSecret"); //key
let nonceStr = getRadomNum(10); //随机字符串
    config.headers["token"] = sessionStorage.getItem("token") || "";
    config.headers["Content-Type"] = "application/json;charset=utf-8";
    config.headers["appSecret"] = sessionStorage.getItem("appSecret") || "";
    config.headers["appId"] = sessionStorage.getItem("appId") || "";
    config.headers["timestamp"] = timestamp;
    config.headers["nonceStr"] = nonceStr;
    config.headers["sign"] = md5(`${timestamp}${appId}${nonceStr}${appSecret}`);
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject();
  }
);

service.interceptors.response.use(
  response => {
    if (response.status == 200) {
      if (response.data.status === 1) {
        return response.data;
      } else {
        if (response.data.message === "权限认证失败") {
          Message.error("权限认证失败,请重新登录");
        } else {
          Message.error(response.data.message);
          return Promise.reject(response.data);
        }
      }
    } else {
      Message.error(response.data.message);
      return Promise.reject(response.data);
    }
  },
  error => {
    console.log(3);
    // this.$message.error(err.response.data.message);
    // Message(error.message)
    return Promise.reject(error);
  }
);

const httpInfo = {
  httpRequest: service,
  Host: Host
};

export default httpInfo;



//////////////////
// WEBPACK FOOTER
// ./static/js/request.js
// module id = null
// module chunks = 